<ng-template [ngIf]="type === 'house'">
  <app-house-details-sd
    [property]="property"
    [agency]="agencyService.agency"
    [breadcrumbs]="propertyService.generateBreadcrums(property)"
  >
  </app-house-details-sd>
</ng-template>
<!-- TODO: REMOVE property.friendly_id !== 'splaiul-unirii' -->
<section
  class="head-navigation"
  *ngIf="type == 'house'"
>
  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    class="container"
  >
    <div
      fxLayout="row"
      fxLayoutAlign="center"
      fxShow="false"
      fxShow.gt-md
    >
      <ul
        fxLayout="row"
        fxLayoutAlign="center"
      >
        <li>
          <a
            routerLink="/apartamente"
          >
            <img
              src="/assets/icons/home_blue.svg"
            >
          </a>
        </li>
        <li
          *ngFor="let breadcrum of propertyService.generateBreadcrums(property)"
        >
          <a
            [routerLink]="breadcrum.routerLink"
            [queryParams]="breadcrum.queryParams"
          >
            {{ breadcrum.translate ? (breadcrum.translate + '.' + breadcrum.name | translate) : breadcrum.name }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</section>

<section class="details">
  <div
    fxLayout="row wrap"
    fxLayoutAlign="space-between"
    class="container"
  >
    <div class="house-details">
      <div
        class="slider"
      >
        <app-images-carousel-base
          [images]="item.images"
        >
        </app-images-carousel-base>
      </div>

      <div class="aw-item house-description">
        <ng-template [ngIf]="type == 'project'">
          <div
            fxLayout="row wrap"
            fxLayoutAlign="space-between start"
          >
            <h2>
              {{ project.name }}
              <h4
                class="project-sale-status"
              >
                {{ 'model.project.sale_status.' + project.sale_status | translate }}
              </h4>
            </h2>
            <label class="project-status">
              {{ 'model.project.status.' + project.status | translate }}
            </label>
          </div>
          <p style="white-space: pre-wrap;">{{ project.description }}</p>
          <h3
            *ngIf="project.status !== 'coming_soon'"
            class="project-description-title"
          >
            Filtrează locuințe:
          </h3>
          <div
            *ngIf="project.status !== 'coming_soon'"
            fxLayout="row wrap"
            fxLayoutAlign="center center"
            class="filters-container"
          >
            <mat-form-field
              class="dropdown-filter"
            >
              <mat-select
                [(ngModel)]="getPropertySearch().availability"
                name="availability"
                [placeholder]="'Disponibilitate'"
              >
                <mat-option
                  [value]="null"
                  (click)="getPropertySearch().for_sale=1; refreshProperties();"
                >
                  Toate
                </mat-option>
                <mat-option
                  [value]="'available'"
                  (click)="getPropertySearch().for_sale=1; refreshProperties();"
                >
                  Disponibilă
                </mat-option>
                <mat-option
                  [value]="'unavailable'"
                  (click)="getPropertySearch().for_sale=1; refreshProperties();"
                >
                  Indisponibilă
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              class="dropdown-filter"
            >
              <mat-select
                [(ngModel)]="getPropertySearch().sort"
                name="sort"
                [placeholder]="'Sortează după'"
              >
                <mat-option
                  *ngFor="let sort of sortItems"
                  [value]="sort.id"
                  (click)="getPropertySearch().for_sale=1; refreshProperties();"
                >
                  {{ sort.text }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <h3
            *ngIf="project.status !== 'coming_soon'"
            class="project-description-title"
          >
            Locuințe
          </h3>
          <section
            *ngIf="project.status !== 'coming_soon'"
            class="properties"
            (window:scroll)="onScroll()"
            #section
          >
            <div
              fxLayout="row wrap"
              fxLayoutAlign="center center"
              class="properties-list project-properties-list"
              *ngIf="properties"
            >
              <a
                *ngFor="let property of properties"
                class="property-item"
                [routerLink]="['/', property.property_type, property.friendly_id]"
              >
                <app-property
                  [property]="property"
                  [type]="'property'"
                >
                </app-property>
              </a>
            </div>
          </section>
        </ng-template>
        <ng-template [ngIf]="type == 'house'">
          <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            class="title-container"
          >
            <h2>
              {{ property.title }}
            </h2>
            <!--
            <label *ngIf="property.for_sale && property.to_let == false">
              <span
                *ngIf="property.friendly_id === 'splaiul-unirii'"
              >
                De la:
              </span>
              {{ property.sale_price | number:'.0-0' }} {{ 'model.currency_id.' + property.currency_id | translate }}
            </label>
            <label *ngIf="property.to_let && property.for_sale == false">
              {{ property.let_price | number:'.0-0' }} {{ 'model.currency_id.' + property.currency_id | translate }}
            </label>
            <label *ngIf="property.to_let && property.for_sale">
              {{ property.sale_price | number:'.0-0' }}
              {{ 'model.currency_id.' + property.currency_id | translate }}/{{ property.let_price | number:'.0-0' }}
              {{ 'model.currency_id.' + property.currency_id | translate }}
            </label>
            -->
          </div>
          <div
            *ngIf="property.friendly_id !== 'splaiul-unirii'"
            fxLayout="row"
            fxLayoutAlign="end center"
            fxLayoutAlign.gt-xs="space-between center"
            class="status-container"
          >
            <label>
              {{ 'model.property.availability.' + property.availability | translate }}
            </label>
          </div>
          <h5
            *ngIf="property.friendly_id !== 'splaiul-unirii'"
          >
            Detalii locuință:
          </h5>
          <div
            *ngIf="property.friendly_id !== 'splaiul-unirii'"
            fxLayout="row wrap"
            class="description-list"
          >
            <table>
              <tbody>
                <tr *ngIf="property.property_type">
                  <td>
                    Tip proprietate:
                  </td>
                  <td>
                    {{ property.property_type }}
                  </td>
                </tr>
                <tr *ngIf="property.home_type">
                  <td>
                    Tip locuință:
                  </td>
                  <td>
                    {{ 'model.property.home_type.' + property.home_type | translate }}
                  </td>
                </tr>
                <tr *ngIf="property.building_type_value">
                  <td>
                    Tip imobil:
                  </td>
                  <td>
                    {{ property.building_type_value }}
                  </td>
                </tr>
                <tr *ngIf="property.built_state">
                  <td>
                    Stadiu construcție:
                  </td>
                  <td>
                    {{ 'model.built_state.' + property.built_state | translate }}
                  </td>
                </tr>
                <tr *ngIf="property.property_type">
                  <td>
                    Tip compartimentare:
                  </td>
                  <td>
                    {{ property.layout_value }}
                  </td>
                </tr>
                <tr *ngIf="property.floor_value == null">
                  <td>
                    Numar etaje:
                  </td>
                  <td>
                    {{ property.floor_count }}
                  </td>
                </tr>
                <tr *ngIf="property.confort_value">
                  <td>
                    Confort:
                  </td>
                  <td>
                    {{ property.confort_value }}
                  </td>
                </tr>
                <tr *ngIf="property.property_type !== 'terenuri'">
                  <td>
                    Caracteristici imobil:
                  </td>
                  <td>
                    {{ characteristics }}
                  </td>
                </tr>
              </tbody>
            </table>
            <table>
              <tbody>
                <tr *ngIf="property.floor_value">
                  <td>
                    Etaj:
                  </td>
                  <td>
                    {{ property.floor_value }} din {{ property.floor_count }}
                  </td>
                </tr>
                <tr *ngIf="property.room_count">
                  <td>
                    Număr camere:
                  </td>
                  <td>
                    {{ property.room_count }} {{ property.room_count == 1 ? 'cameră' : 'camere' }}
                  </td>
                </tr>
                <tr *ngIf="property.bathroom_count">
                  <td>
                    Număr băi:
                  </td>
                  <td>
                    {{ property.bathroom_count }} {{ property.bathroom_count == 1 ? 'baie' : 'băi' }}
                  </td>
                </tr>
                <tr *ngIf="property.usable_size_sqm">
                  <td>
                    Suprafața utilă:
                  </td>
                  <td>
                    {{ property.usable_size_sqm | number:'.0-0' }}m<sup>2</sup>
                  </td>
                </tr>
                <tr *ngIf="property.total_size_sqm">
                  <td>
                    Suprafața totală:
                  </td>
                  <td>
                    {{ property.total_size_sqm | number:'.0-0' }}m<sup>2</sup>
                  </td>
                </tr>
                <tr *ngIf="property.built_size_sqm">
                  <td>
                    Suprafața construită:
                  </td>
                  <td>
                    {{ property.built_size_sqm | number:'.0-0' }}m<sup>2</sup>
                  </td>
                </tr>
                <tr *ngIf="property.year_built">
                  <td>
                    An construcție:
                  </td>
                  <td>
                    {{ property.year_built }}
                  </td>
                </tr>
                <tr *ngIf="property.project">
                  <td>
                    Proiect:
                  </td>
                  <td>
                    <a [routerLink]="['/portofoliu', 35]">
                      <h4>
                        {{ property.project.name }}
                      </h4>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--
          <div
            class="files"
            *ngIf="property.documents.length && property.friendly_id !== 'splaiul-unirii'"
          >
            <h5>
              Plan locuință:
            </h5>
            <a
              *ngFor="let file of property.documents"
              [href]="file.url"
              target="_blank"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <span>
                {{ file.name }}
              </span>
              <label>
                Descarcă
              </label>
            </a>
          </div>
          <p
            *ngIf="property.friendly_id !== 'splaiul-unirii'"
            [innerHTML]="property.description"
          >
          </p>
          <p
            *ngIf="property.friendly_id === 'splaiul-unirii'"
            class="description-soon"
          >
            Preturile afisate sunt valabile pana la data de 01.09.2018
          </p>
          -->
        </ng-template>
      </div>
    </div>
    <aside>
      <div
        class="aside-details"
      >
        <p
          class="aside-details-content"
        >
          Pentru detalii suplimentare și vizionări vă rugăm să ne contactați prin intermediul
          <a routerLink="/contact">paginii contact</a>
          afișata pe website-ul proiecteimobiliaresoava.ro.
          Vă mulțumim pentru înțelegere. O zi plăcută!
        </p>
      </div>
      <ng-template
        *ngIf="type === 'project'"
      >
        <div
          class="aside-details"
        >
          <h2
            *ngIf="project.available_properties_count"
            class="available-properties-number"
          >
            Proprietăți disponibile: {{ project.available_properties_count }}
          </h2>
        </div>
      </ng-template>
      <div class="properties">
        <ng-template [ngIf]="type == 'house'">
          <ng-template [ngIf]="promoProperties">
            <h2
              *ngIf="property.friendly_id !== 'splaiul-unirii'"
            >
              Alte proprietăți recomandate:
            </h2>
            <div
              class="properties-list"
            >
              <div
                *ngFor="let promoProperty of promoProperties | slice:0:2"
              >
                <a
                  *ngIf="property.friendly_id != promoProperty.friendly_id"
                  class="property-item"
                  [routerLink]="['/', promoProperty.property_type, promoProperty.friendly_id]"
                >
                  <app-property
                    [property]="promoProperty"
                    [type]="'property'"
                  >
                  </app-property>
                </a>
              </div>
            </div>
          </ng-template>
        </ng-template>

        <ng-template [ngIf]="type == 'project'">
          <h2>
            Alte proiecte recomandate:
          </h2>
          <div class="properties-list projects-aside-list">
            <div
              *ngFor="let relatedProject of relatedProjects | slice:0:2"
            >
              <a
                class="project-item"
                [routerLink]="['/portofoliu', relatedProject.id]"
              >
                <app-property
                  [project]="relatedProject"
                  [type]="'project'"
                >
                </app-property>
              </a>
            </div>
          </div>
          <div class="center">
            <a
              mat-raised-button
              color="main-color"
              routerLink="/portofoliu"
            >
              vezi mai multe
            </a>
          </div>
        </ng-template>
      </div>
    </aside>
  </div>
</section>



// WEBPACK FOOTER //
// ./src/app/houses/house-details.component.html